import React, { useEffect, useReducer, useContext, useState } from 'react'
// import { RecyclerListView, DataProvider, LayoutProvider } from 'recyclerlistview/web';
import { Container, Row, Col } from 'react-bootstrap';
import AuthContext from '../../context/auth-context';
import { Button, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TableSortLabel, Paper, InputBase } from '@material-ui/core';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import Dropdown from 'react-bootstrap/Dropdown'
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import SearchIcon from '@material-ui/icons/Search'
import useStyles from '../../Desain/useStylesTabel'
import Skeleton from 'react-loading-skeleton';
import mControl from './UserLaporan.ctrl'
import ModalForm from './Modal.UserLaporan'
import LockIcon from '@material-ui/icons/Lock';
import ModalResetPassword from './Modal.GantiPassword'


const loadingRow = [0, 1, 2, 3, 4];

const desc = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const stableSort = (array, cmp) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

const getSorting = (order, orderBy) => {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}
const headRows = [
    { id: "email", label: "E-mail" },
    { id: "namacustomer", label: "Nama Customer" },
    { id: "nohp", label: "No HP" },

];

const UserLaporan = (props) => {
    let defaultPage = parseInt(props.match.params.page, 10) - 1;
    let defaultrowsPerPage = parseInt(props.match.params.rowsPerPage, 10);
    const { clientID, token } = useContext(AuthContext);
    const classes = useStyles();
    const [order, setOrder] = React.useState("desc");
    const [orderBy, setOrderBy] = React.useState("idcust");
    const [page, setPage] = React.useState(defaultPage);
    const [rowsPerPage, setRowsPerPage] = React.useState(defaultrowsPerPage);
    const [search, setSearch] = useState(null)
    const [dataOri, setDataOri] = useState([])
    const [listData, setListData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [dataSelect, setDataSelect] = useState({})
    const [isOpenForm, setIsOpenForm] = useState(false)
    const [isResetPass, setIsResetPass] = useState(false)


    useEffect(() => {
        mControl.loadUserLaporan(clientID, token).then(resp => {
            setListData(resp)
            setDataOri(resp)
        }).catch(err => {
            console.error(err);
        }).finally(() => setIsLoading(false))
        return () => {

        };
    }, [isLoading, clientID, token])

    const addOutlet = () => {
        setDataSelect({})
        setIsOpenForm(true)
    }

    const handleEdit = (data) => {
        setDataSelect(data)
        setIsOpenForm(true)
    }
    const handleOutlet = data => {
        props.history.push(`/userlaporan/${data.email}/${page + 1}/${rowsPerPage}`)
    }
    const handlePassword = data => {
        setDataSelect(data)
        setIsResetPass(true)
    }

    const handleDelete = data => {
        const konfirm = window.confirm(`Yakin akan menghapus user ${data.email}?`);
        if (konfirm) {
            mControl.hapusUserCustomer(clientID, token, data.email).then(resp => {
                alert("User berhasil di hapus")
                setIsLoading(true)
            }).catch(err => {
                if (err.length > 0) {
                    alert(err[0].message)
                } else if (typeof err) {
                    alert(err.message)
                } else {
                    console.log(err);
                }
            })
        }
    }

    const handleRequestSort = (event, property) => {
        const isDesc = orderBy === property && order === "desc";
        setOrder(isDesc ? "asc" : "desc");
        setOrderBy(property);
    }
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    }
    const EnhancedTableHead = (props) => {
        const {
            classes,
            order,
            orderBy,
            onRequestSort
        } = props;
        const createSortHandler = property => event => {
            onRequestSort(event, property);
        };
        return (
            <TableHead>
                <TableRow>
                    {headRows.map(row => (
                        <TableCell key={row.id}>
                            <TableSortLabel
                                active={orderBy === row.id}
                                direction={order}
                                onClick={createSortHandler(row.id)}
                            >
                                {row.label}
                                {orderBy === row.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === "desc" ? "sorted descending" : "sorted ascending"}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                    <TableCell style={{ width: ' 25px' }}>Action</TableCell>
                </TableRow>
            </TableHead>
        );
    }
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, listData.length - page * rowsPerPage);
    const searchHandler = (val) => {
        setSearch(val.target.value)
    }
    const formSubmitHandler = () => {
        setPage(0)
        setRowsPerPage(5)
        if (search) {
            const results = dataOri.filter(el => {
                return el.email.toUpperCase().match(search.toUpperCase()) || el.namacustomer.toUpperCase().match(search.toUpperCase()) || el.nohp.toUpperCase() === search.toUpperCase();
            })
            setListData(results)
        } else {
            setListData(dataOri)
        }
    }
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            formSubmitHandler()
        }
    }
    return (
        <Container>
            <Row>
                <Col xs={12}>
                    <h4 style={{ marginTop: 20, paddingBottom: 10 }} className="border-bottom">User Laporan</h4>
                    <Button variant="contained" color="primary" onClick={addOutlet}>Add New</Button>
                    <Paper className="table-responsive" style={{ marginTop: 10 }}>
                        <div className="btnTable">
                            <Row>
                                <Col>
                                    <div className={classes.search}>
                                        <div className={classes.searchIcon}>
                                            <SearchIcon />
                                        </div>
                                        <InputBase onChange={searchHandler} onKeyPress={handleKeyPress}
                                            placeholder="Search…"
                                            classes={{
                                                root: classes.inputRoot,
                                                input: classes.inputInput,
                                            }}
                                            inputProps={{ 'aria-label': 'search' }}
                                        />
                                        <Button style={{ float: 'right' }} onClick={formSubmitHandler} variant="contained" color="primary">Cari</Button>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className={classes.tableWrapper}>
                            <Table
                                className="table"
                                aria-labelledby="tableTitle"
                                size={"small"}
                            >
                                <EnhancedTableHead
                                    classes={classes}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={listData.length}
                                />
                                {isLoading && loadingRow.map(el => (
                                    <TableRow
                                        key={el.toString()}
                                        style={{ height: 50 }}
                                    >
                                        <TableCell>
                                            <Skeleton />
                                        </TableCell>
                                        <TableCell>
                                            <Skeleton />
                                        </TableCell>
                                        <TableCell>
                                            <Skeleton />
                                        </TableCell>
                                        <TableCell>
                                            <Skeleton />
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {stableSort(listData, getSorting(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => {
                                        return (
                                            <TableRow
                                                hover
                                                key={index}
                                                role="checkbox"
                                            >
                                                <TableCell>
                                                    {row.email}
                                                </TableCell>
                                                <TableCell>
                                                    {row.namacustomer}
                                                </TableCell>
                                                <TableCell>
                                                    {row.nohp}
                                                </TableCell>
                                                <TableCell>
                                                    <Dropdown>
                                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                            <TouchAppIcon id="dropdown-basic" /></Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item><Button title="Edit" variant="contained" style={{ backgroundColor: '#376275', marginRight: 10, color: "#fff", width: '150px' }} onClick={handleEdit.bind(this, row)}><EditIcon /> Edit/lihat</Button></Dropdown.Item>
                                                            <Dropdown.Item><Button title="Hapus" variant="contained" style={{ backgroundColor: 'red', marginRight: 10, color: "#fff", width: '150px' }} onClick={handleDelete.bind(this, row)}><DeleteIcon /> Hapus</Button></Dropdown.Item>
                                                            <Dropdown.Item><Button title="Reset Password" variant="contained" style={{ backgroundColor: '#3b6be6', marginRight: 10, color: "#fff", width: '150px' }} onClick={handlePassword.bind(this, row)}><LockIcon />Reset Password</Button></Dropdown.Item>
                                                            <Dropdown.Item><Button title="List Outlet" variant="contained" style={{ backgroundColor: '#5bc0de', marginRight: 10, color: "#fff", width: '150px' }} onClick={handleOutlet.bind(this, row)}><VisibilityIcon /> List Outlet</Button></Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                {emptyRows > 0 && (
                                    <TableRow style={{ height: 49 * emptyRows }}>
                                        <TableCell colSpan={7} />
                                    </TableRow>
                                )}
                                <TableBody>

                                </TableBody>
                            </Table>
                        </div>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            component="div"
                            count={listData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            backIconButtonProps={{
                                "aria-label": "previous page"
                            }}
                            nextIconButtonProps={{
                                "aria-label": "next page"
                            }}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </Paper>
                </Col>
            </Row>
            {isOpenForm && <ModalForm open={isOpenForm} setOpen={setIsOpenForm} dataSelect={dataSelect} clientID={clientID} token={token} setIsLoading={setIsLoading} />}
            {isResetPass && <ModalResetPassword open={isResetPass} setOpen={setIsResetPass} dataSelect={dataSelect} clientID={clientID} token={token} />}
        </Container>
    )
}

export default UserLaporan;